/**
 * Privacy helper for displaying another user's name.
 *
 * We only ever expose a person's first name and the initial of their last name
 * (e.g. "John D.") to other users — never their full last name.
 */

/** Returns the uppercased first letter of the last name followed by a period, or "" if none. */
export function lastNameInitial(lastName?: string | null): string {
  const last = lastName?.trim();
  return last ? `${last.charAt(0).toUpperCase()}.` : "";
}

/** Formats a name as "First L." — first name plus last-name initial. */
export function formatNameWithInitial(
  firstName?: string | null,
  lastName?: string | null
): string {
  const first = firstName?.trim() || "";
  const initial = lastNameInitial(lastName);
  return initial ? `${first} ${initial}`.trim() : first;
}
